import React, { useState } from 'react';
import Datatable from '../../../components/Datatable';
import moment from 'moment';
import EmpresaSelect from '../../../components/EmpresaSelect';

const getItem = (storage, key) => {
    const data = localStorage.getItem(storage)
    return data ? Object.keys(JSON.parse(data)).includes(key) ? JSON.parse(data)[key] : null : null
}

export default function Audit() {
    const [refresh, setRefresh] = useState(false)
    const [empresa, setEmpresa] = useState(getItem('hermes', 'empresa') || null)

    React.useEffect(() => {
        document.title = "IPV7 Hermes - Logs de Auditoria"
    }, [])

    return (
        <Datatable
            refresh={refresh}
            empresa={empresa}
            handlerRefresh={() => setRefresh(!refresh)}
            title='Logs de Auditoria'
            endpoint='/admin/hermes/audit'
            options={{
                customToolbar: () => (
                    <EmpresaSelect
                        sx={{ width: '400px' }}
                        value={empresa}
                        handler={(e) => {
                            localStorage.setItem('hermes', JSON.stringify({ empresa: e }))
                            setEmpresa(e)
                        }}
                    />
                ),
                customToolbarSelect: () => ""
            }}
            columns={[
                {
                    name: 'id',
                    label: "ID",
                    options: {
                        filter: false,
                        sort: false,
                        display: false
                    }
                },
                {
                    name: "empresa_name",
                    label: 'Empresa',
                },
                {
                    name: "username",
                    label: 'Usuário',
                },
                {
                    name: "message",
                    label: 'Mensagem',
                },
                {
                    name: "created_at",
                    label: "Data",
                    options: {
                        customBodyRender: value => (
                            <span>{moment(value).locale('pt-br').format('DD/MM/YYYY HH:mm:ss')}</span>
                        ),
                    }
                },
            ]}
        />
    )
}
